export default "__VITE_ASSET__BMvIOH4W__"